__webpack_require__.p = "https://bmidxbslovakiaplpreprod.netlify.app/";